import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CampaignAnalytics from './CampaignAnalytics';
import SupplierList from './SupplierAnalytics/SupplierList';
import UserAnalytics from './UserAnalytics';
import CitywiseAnalytics from './CitywiseAnalytics';
import EntityCityWiseCount from './CitywiseAnalytics/EntityCityWiseCount';
import EntityList from './CitywiseAnalytics/EntityList';

const OperationsDashboard = () => {
  return (
    < div >
      <Routes>
        <Route exact path={'/'} element={<CampaignAnalytics />} />
        <Route exact path={`/:campaignId/suppliers`} element={<SupplierList />} />
        <Route exact path={`/entity/*`} element={<CitywiseAnalytics />} />
        <Route exact path={`/city/:type`} element={<EntityCityWiseCount />} />
        <Route exact path={`/city/:type/:city`} element={<EntityList />} />
        <Route exact path={`/city/:type/suppliers`} element={<SupplierList r />} />
        <Route exact path={`/user`} element={<UserAnalytics />} />
      </Routes>
    </div >
  );
}

export default OperationsDashboard;
